/**
 * Ошибка парсинга SMF. Содержит позицию в исходных байтах и причину —
 * используется как `err.position` для диагностики «на каком байте упало».
 */
export class MidiParseError extends Error {
  readonly position: number;
  readonly reason: string;

  constructor(reason: string, position: number) {
    super(`${reason} @ ${position}`);
    this.name = "MidiParseError";
    this.reason = reason;
    this.position = position;
  }
}